import { Banner } from '@cad-arc';

export function DexDeviceIdentificationBanner({
    onClose,
}: {
    onClose: () => void;
}): React.ReactElement {
    return (
        <Banner
            status="attention"
            title="Data Exchange Error: Device Identification"
            description="The Mark43 Desktop Integration Service is not installed or not running. Make sure DIS is functioning properly and contact an administrator if this error persists."
            style={{ width: '100%' }}
            onClose={onClose}
        />
    );
}
